  $(function () {
    function activateTab(tabId) {
      $('.vertical-tabs-nav button, .vertical-tabs-content-item').removeClass('active');
      $(`.vertical-tabs-nav button[data-tab="${tabId}"], #${tabId}`).addClass('active');
    }

    function checkHash() {
      let tabId = location.hash.replace('#', '');
      if (tabId) activateTab(tabId);
    }

    $('.vertical-tabs-nav button, a[href*="#tab-"]').on('click', function (e) {
      let tabId = $(this).data('tab') || this.hash.slice(1);
      if (tabId) {
        activateTab(tabId);
        history.pushState(null, null, '#' + tabId);
      }
    });

    $(window).on('hashchange', checkHash);
    checkHash();
  });

document.addEventListener('DOMContentLoaded', function () {
  const intervalId = setInterval(function () {
    const formEmbed = document.querySelector('form-embed');

    if (formEmbed && formEmbed.shadowRoot) {
      clearInterval(intervalId);
      const shadowRoot = formEmbed.shadowRoot;

      const styleEl = document.createElement('style');
      styleEl.textContent = `
        ._formFieldContainer_ck6wz_5:focus-within textarea + ._formInputFieldLabel_ck6wz_38 {
          min-width: 104% !important;
        }
      `;
      shadowRoot.appendChild(styleEl);

      // Apply label styles + textarea character limit
      const styleTextareaLabels = () => {
        const containers = shadowRoot.querySelectorAll('._formFieldContainer_ck6wz_5');
        containers.forEach(container => {
          const textarea = container.querySelector('textarea');
          if (textarea) {
            if (!textarea.hasAttribute('maxlength')) {
              textarea.setAttribute('maxlength', '70'); // Set character limit to 70
            }

            // Style the label
            const label = container.querySelector('label');
            if (label && !label.classList.contains('textarea-label')) {
              label.classList.add('textarea-label');
              label.style.backgroundColor = '#fff';
              label.style.display = 'inline-block';
              label.style.minWidth = '95%';
            }
          }
        });
      };

      styleTextareaLabels();

      const observer = new MutationObserver(styleTextareaLabels);
      observer.observe(shadowRoot, { childList: true, subtree: true });
    }
  }, 100);
});

document.addEventListener("DOMContentLoaded", () => {
  const currentHandle = decodeURIComponent(window.location.pathname.split("/").pop());

  // Product mapping: normal → kickflip
  const mapping = {
    "the-coffee-run-1": "the-coffee-run-2",
    "the-valet-1": "the-valet-2"
  };

  // Kickflip product handles
  const kickflipHandles = Object.values(mapping);

  // Hide custom button if we are on a Kickflip product
  const customBuyButtonWrapper = document.querySelector(".custom-buy-button");
  if (kickflipHandles.includes(currentHandle) && customBuyButtonWrapper) {
    customBuyButtonWrapper.style.display = "none";
  }

  // On normal products — redirect to Kickflip product with ?from param
  const customBuyButton = document.querySelector(".custom-buy-button button");
  if (customBuyButton && mapping[currentHandle]) {
    customBuyButton.addEventListener("click", () => {
      window.location.href = `/products/${mapping[currentHandle]}?from=${currentHandle}`;
    });
  }

  // On Kickflip products — auto-open modal if came from mapped product
  const urlParams = new URLSearchParams(window.location.search);
  const fromProduct = decodeURIComponent(urlParams.get("from") || "");

  // // // Reverse mapping: kickflip → normal
  const reverseMapping = Object.fromEntries(
    Object.entries(mapping).map(([normal, kickflip]) => [kickflip, normal])
  );

  if (kickflipHandles.includes(currentHandle) && reverseMapping[currentHandle] === fromProduct) {
    const kickflipButton = document.querySelector("#kickflip-customize-button");
    if (kickflipButton) {
      console.log(`Came from ${fromProduct} → opening Kickflip popup...`);
      kickflipButton.click();
    }
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const btn = document.querySelector('#kickflip-customize-button');
    if (btn) {
      btn.textContent = 'Customize';
      clearInterval(interval);
    }
  }, 300);
});



